export default __webpack_public_path__ + "static/media/icon-arkademi.197239ec.svg";